import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { FeaturedVenue } from '../models/FeaturedVenue'
import { FEATURED_VENUES_LIVE_URL, FEATURED_VENUES_URL } from '../utils/urls'

const fetchFeaturedVenues = (params: TableParams) =>
  SBAPI.FetchPaginated<FeaturedVenue[]>(FEATURED_VENUES_URL, params)

const fetchFeaturedVenuesLive = () =>
  SBAPI.Fetch<FeaturedVenue>(FEATURED_VENUES_LIVE_URL)

const fetchFeaturedVenuesById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<FeaturedVenue>(`${FEATURED_VENUES_URL}/${id}`, params)

const createFeaturedVenues = (featuredVenues: FeaturedVenue) =>
  SBAPI.Post(FEATURED_VENUES_URL, featuredVenues)

const updateFeaturedVenues = (featuredVenues: FeaturedVenue) =>
  SBAPI.Put(`${FEATURED_VENUES_URL}/${featuredVenues.id}`, featuredVenues)

const deleteFeaturedVenues = (featuredVenues: FeaturedVenue) =>
  SBAPI.Delete(`${FEATURED_VENUES_URL}/${featuredVenues.id}`)

export {
  createFeaturedVenues,
  deleteFeaturedVenues,
  fetchFeaturedVenues,
  fetchFeaturedVenuesById,
  fetchFeaturedVenuesLive,
  updateFeaturedVenues,
}
